import React, { useEffect, useMemo, useState } from "react";
import { Card, Form } from "react-bootstrap";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Navigate } from "react-router-dom";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
import { clubListResponce } from "../../store/features/club/clubSlice";
import useAuth from "../../hooks/useAuth";
import "./tableBooking.css";

const TableBookingClubPicker = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isClubManager, managedClubId } = useAuth();
  const clubList = useSelector((state) => state?.club?.clubList ?? []);
  const loading = useSelector((state) => state?.club?.loading);
  const [search, setSearch] = useState("");
  const [clubId, setClubId] = useState("");

  useEffect(() => {
    if (!Array.isArray(clubList) || clubList.length === 0) {
      dispatch(clubListResponce());
    }
  }, [dispatch, clubList.length]);

  const filtered = useMemo(() => {
    if (!Array.isArray(clubList)) return [];
    const q = search.trim().toLowerCase();
    if (!q) return clubList;
    return clubList.filter(
      (c) =>
        c?.name?.toLowerCase().includes(q) ||
        c?.slug?.toLowerCase().includes(q) ||
        String(c?._id || c?.id || "")
          .toLowerCase()
          .includes(q)
    );
  }, [clubList, search]);

  const onContinue = () => {
    if (!clubId) return;
    navigate(`/clubs/${clubId}/table-booking`);
  };

  if (isClubManager && managedClubId) {
    return (
      <Navigate to={`/clubs/${managedClubId}/table-booking`} replace />
    );
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>{t("TABLE_BOOKING_MENU")} | RizzTix</title>
      </Helmet>
      <div className="pageContent categoryManagement">
        <div className="category">
          <Breadcrumbs
            innerPagetitle={t("TABLE_BOOKING_CLUB_PICK_TITLE")}
            breadcrumbItem={t("TABLE_BOOKING_MENU")}
            pageTitle={[
              { title: t("EVENTS"), path: "/events-list" },
              {
                title: t("TABLE_BOOKING_MENU"),
                path: "/clubs-table-booking",
              },
            ]}
            BreadcrumbInner={true}
            BreadcrumbmainTitle={true}
          />
          <Card className="mainCard mainCardWrapper">
            <Card.Body>
              <h5 className="mb-3">{t("TABLE_BOOKING_CLUB_PICK_TITLE")}</h5>
              <p className="text-muted small mb-4">
                {t("TABLE_BOOKING_CLUB_PICK_HELP")}
              </p>
              <div className="table-booking-club-select">
                <Form.Group className="mb-3">
                  <Form.Label>{t("TABLE_BOOKING_SEARCH_LABEL")}</Form.Label>
                  <Form.Control
                    type="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder={t("TABLE_BOOKING_CLUB_SEARCH_PLACEHOLDER")}
                    autoComplete="off"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>{t("CLUBS")}</Form.Label>
                  <Form.Select
                    value={clubId}
                    onChange={(e) => setClubId(e.target.value)}
                    disabled={loading}
                  >
                    <option value="">{t("TABLE_BOOKING_SELECT_CLUB")}</option>
                    {filtered.map((c) => {
                      const id = String(c?._id ?? c?.id ?? "");
                      return (
                        <option key={id || c.slug} value={id}>
                          {c?.name || c?.slug || id}
                          {c?.slug ? ` — ${c.slug}` : ""}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
                <button
                  type="button"
                  className="btn btn-primary fillButton"
                  disabled={!clubId}
                  onClick={onContinue}
                >
                  {t("TABLE_BOOKING_CONTINUE")}
                </button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TableBookingClubPicker;
